import { SearchTab } from '@habity/types';
import { ReadonlyURLSearchParams } from 'next/navigation';
import { getQueryParamsString } from '../neondatabase';
import { createClient } from './client';
import { API_PATHS } from '@habity/constants';
import { getUserDataFullQuery } from './users/query';

/**
 * Get Supabase select columns for a table
 * For 'users' table, uses shared query from ./users/query.ts - SINGLE SOURCE OF TRUTH
 */
export const getTableColums = (table: TODO) => {
  switch (table) {
    case 'users':
      return getUserDataFullQuery();
    default:
      return '*';
  }
};

export const getAll = async (
  table: TODO,
  agencyId: string | null,
  userId?: string | null
): Promise<TODO[]> => {
  const supabase = createClient();
  // SUPABASE: Call backend fn instead of sb directly
  const query = supabase
    .from(table)
    .select(getTableColums(table))
    .eq('agency_id', Number(agencyId));

  if (userId) {
    query.eq('user_id', userId);
  }

  const { data, error } = await query.returns<TODO[]>();
  if (error) {
    throw error;
  }
  return data;
};

export const get = async (
  table: TODO,
  id?: number | null
): Promise<TODO | null> => {
  if (!id) {
    return null;
  }
  const supabase = createClient();
  // SUPABASE: Call backend fn instead of sb directly
  const query = supabase.from(table).select(getTableColums(table)).eq('id', id);

  // TODO: Add agency id to call
  // if (table === 'users') {
  //   query.eq('homes.agency_id', null).or(`id.eq.${id}`);
  // }

  const { data, error } = await query.returns<TODO[]>().maybeSingle();
  if (error) {
    throw error;
  }
  return data;
};

export const getTableKey = ({
  page,
  previousPageData,
  tab,
  searchParams = null,
  searchId = null,
  addressId = null,
  authUserId,
  limit,
  useLimitAsTotalCount = false,
  showBuyerDetails = false,
}: {
  page: number;
  previousPageData: TODO[][];
  tab: SearchTab;
  searchParams?: ReadonlyURLSearchParams | null;
  searchId?: string | string[] | null;
  addressId?: string | string[] | null;
  authUserId?: string;
  limit?: number;
  useLimitAsTotalCount?: boolean;
  showBuyerDetails?: boolean;
}): string | null => {
  if (previousPageData && !previousPageData.length) return null;

  // Create params object with the correct type
  const params: Parameters<typeof getQueryParamsString>[0] = {
    page: page.toString(),
    searchParams,
    searchId: searchId ? searchId.toString() : undefined,
    addressId: addressId ? addressId.toString() : undefined,
    authUserId,
    limit,
    useLimitAsTotalCount,
    showBuyerDetails,
  };

  const key = `${API_PATHS.PROVIDERS.NEONDATABASE.ROOT}/${tab}?${getQueryParamsString(params)}`;
  return key;
};
